// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddWorkflowMutation($input: AddWorkflowInput!) {
    addWorkflow(input: $input) {
      workflowEdge {
        cursor
        node {
          id
          name
          isDefault
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'Workflows_workflows',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'workflowEdge',
        },
      ],
    });
  },
};
